import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "@/inventory/lib/auth.server"
import {
  createSupplyCategory,
  ensureDefaultCategories,
  listSupplyCategories,
  updateSupplyCategory,
} from "../lib/categories.server"

export const listSupplyCategoriesFn = createServerFn({ method: "GET" })
  .validator((data?: { includeInactive?: boolean }) => data)
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listSupplyCategories(data)
  })

export const createSupplyCategoryFn = createServerFn({ method: "POST" })
  .validator((data: unknown) => z.object({ name: z.string() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createSupplyCategory(data.name)
  })

export const updateSupplyCategoryFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateSupplyCategory(data)
  })

export const ensureDefaultCategoriesFn = createServerFn({
  method: "POST",
}).handler(async () => {
  await requireInventoryUserId()
  return ensureDefaultCategories()
})
